import React, { Component } from 'react';
import './Sidenav.css';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setNavBarState } from '../../../actions/layoutActions';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { HashLink } from "react-router-hash-link";


class Sidenav extends Component {

  closeClickHandler = () => {
    this.props.setNavBarState();
  }

  render() {
    return (
      <div
        className={classnames('sidenav-wrapper', {
          'visible': this.props.open
        })}
      >
        <div className="sidenav-background" onClick={this.closeClickHandler}></div>
        <div className="sidenav">
          <div className="close-btn" onClick={this.closeClickHandler}>
            &times;
          </div>

          <div className="top-wrapper"></div>

          <Link to="/" className="menu-item" onClick={this.closeClickHandler}>
            <i className="fas fa-home"></i>
            Kezdőlap
            <i className="fas fa-angle-right"></i>
          </Link>
          <HashLink smooth to="/#rolam" className="menu-item" onClick={this.closeClickHandler}>
            <i className="far fa-user"></i>
            Rólam
            <i className="fas fa-angle-right"></i>
          </HashLink>
          <HashLink smooth to="/#modszertan" className="menu-item" onClick={this.closeClickHandler}>
            <i className="fas fa-info"></i>
            Módszertan
            <i className="fas fa-angle-right"></i>
          </HashLink>
          <HashLink smooth to="/#velemenyek" className="menu-item" onClick={this.closeClickHandler}>
            <i className="fas fa-bullhorn"></i>
            Vélemények
            <i className="fas fa-angle-right"></i>
          </HashLink>
          <HashLink smooth to="/#kurzusok" className="menu-item" onClick={this.closeClickHandler}>
            <i className="fas fa-book"></i>
            Kurzusok
            <i className="fas fa-angle-right"></i>
          </HashLink>
          <HashLink smooth to="/#blog" className="menu-item" onClick={this.closeClickHandler}>
            <i className="far fa-newspaper"></i>
            Blog
            <i className="fas fa-angle-right"></i>
          </HashLink>
          <Link to="/kapcsolat" className="menu-item" onClick={this.closeClickHandler}>
            <i className="fas fa-envelope"></i>
            Kapcsolat
            <i className="fas fa-angle-right"></i>
          </Link>
        </div>
      </div>
    );
  }
}


Sidenav.propTypes = {
  setNavBarState: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};


const mapStateToProps = (state) => ({
  open: state.layout.nav.open
});


export default connect(mapStateToProps, { setNavBarState })(Sidenav);



// WEBPACK FOOTER //
// ./src/components/layout/Sidenav/Sidenav.js